import { StoreRootState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Outlet, useNavigate } from 'react-router-dom';
import { personaHomePage } from '@/utils/constants';

const IsAlreadyAuth = () => {
	const navigate = useNavigate();
	const { user } = useSelector((state: StoreRootState) => state.auth);
	useEffect(() => {
		if (user) navigate(personaHomePage[user?.role]);
	}, [user]);
	return <Outlet />;
};

export default IsAlreadyAuth;
